import { useFormContext } from 'react-hook-form';
import { oneLine } from 'common-tags';

import type { FunctionComponent } from 'react';
import type { TypeCheckboxProps } from './types';

/**
 * Checkbox
 */
export const Checkbox: FunctionComponent<TypeCheckboxProps> = ({
  className = '',
  text,
  name,
  requiredMessage,
}: TypeCheckboxProps) => {
  const {
    register,
    formState: { errors },
    setValue,
    trigger,
  } = useFormContext();

  return (
    <div className={`flex flex-col gap-2 ${className}`}>
      <div className="flex gap-2">
        <div className="h-5 min-w-[15px]">
          <input
            className={oneLine`
             cursor-pointer
            ${errors[name] ? 'border-[#ff0000]' : 'accent-primary-400'}
          `}
            {...register(name, { required: requiredMessage })}
            type="checkbox"
            id={name}
            onChange={async (e) => {
              setValue(name, e.target.checked);
              await trigger(name);
            }}
          />
        </div>
        <label
          className={`text-other text-other--detail cursor-pointer ${
            errors[name] ? 'text-[#ff0000] ' : 'text-primary-400'
          }`}
          htmlFor={name}
        >
          {requiredMessage && ' *'}
          {text}
        </label>
      </div>
      {errors[name] && (
        <span
          className={oneLine`
          text-other--detail text-[#ff0000]
          ${errors[name] ? 'block' : 'hidden'}
        `}
        >
          {requiredMessage}
        </span>
      )}
    </div>
  );
};
Checkbox.displayName = 'Checkbox';
